<template>
  <section class="py-9 tablet:py-20" :class="backgroundClass">
    <div class="container-wrap">
      <ul class="column-421">
        <li class="tablet:col-span-2">
          <h2 class="text-h2 mb-10 tablet:line-clamp-2">
            {{ title }}
          </h2>
          <TheRichText
            v-if="descriptionHtml || description"
            class="mb-10 w-full text-sm leading-6 text-gray-700 tablet:line-clamp-7 tablet:text-base"
            :text="descriptionHtml || description"
            :is-html="!!descriptionHtml"
          />
        </li>
        <li v-for="item in items" :key="hash(item)" class="mb-4">
          <div class="mb-4 flex items-center gap-4">
            <figure
              class="h-12 w-12 basis-12 tablet:h-[78px] tablet:w-[78px] tablet:basis-[78px] desktop:h-20 desktop:w-20 desktop:basis-20"
            >
              <img
                :src="item.thumbnail"
                :alt="item.name || item.description"
                class="pointer-events-none block h-full w-full"
              />
            </figure>
            <div class="flex-1">
              <h3 class="text-h5 line-clamp-2">
                {{ item.name }}
              </h3>
            </div>
          </div>
          <TheRichText
            class="element-description text-sm leading-6 text-gray-700 tablet:line-clamp-6"
            :text="item.descriptionHtml || item.description"
            :is-html="!!item.descriptionHtml"
          />
        </li>
      </ul>
    </div>
  </section>
</template>

<script setup lang="ts">
  /**
   * @see https://www.figma.com/design/QJ3ZvEbUHI9xI11iudYf8U/Advantech-WISE-Library?node-id=12796-23839&t=89PIFDiQEC4zcSbf-0
   */

  import hash from 'object-hash';

  interface IItem {
    name: string;
    description?: string;
    descriptionHtml?: string;
    thumbnail: string;
  }

  interface IProps {
    title: string;
    description?: string;
    descriptionHtml?: string;
    items: IItem[];
    theme?: TTheme;
  }

  const props = withDefaults(defineProps<IProps>(), {
    description: undefined,
    descriptionHtml: undefined,
    theme: 'blue',
  });

  const backgroundClass = computed((): string => {
    switch (props.theme) {
      case 'green':
        return 'bg-gradient-to-tr from-green-100 to-green-150';
      case 'cyan':
        return 'bg-gradient-to-tr from-white to-cyan-150';
      case 'purple':
        return 'bg-gradient-to-tr from-purple-100 to-purple-150';
      case 'yellow':
        return 'bg-gradient-to-tr from-yellow-100 to-yellow-150';
      default:
        return 'bg-gradient-to-tr from-blue-50 to-blue-150';
    }
  });

  export type { IItem };
</script>

<style lang="scss" scoped>
  .element-description:deep(a) {
    @apply font-bold text-blue-400 underline;
  }

  .element-description:deep(ul) {
    padding-left: 1.75rem; // 28px
    list-style-type: disc;
  }

  .element-description:deep(ol) {
    padding-left: 1.5rem;
    list-style-type: decimal;
  }
</style>
